import ComposeBookingStep from '../../../../types/ComposeBookingStep';

const determineDirection = (
    stepOrder: Array<ComposeBookingStep>,
    newStep: ComposeBookingStep,
    previousStep?: ComposeBookingStep
) => {
    if (!previousStep) {
        return 1;
    }

    if (newStep === previousStep) {
        return 0;
    }

    const newIndex = stepOrder.indexOf(newStep);
    const previousIndex = stepOrder.indexOf(previousStep);

    return newIndex >= previousIndex ? 1 : -1;
};

export default determineDirection;
